import React from 'react';

import { ISize } from '@/types/cms';
import Description from './description';
import Icon from './icon';
import SubTitle from './sub-title';
import Title from './title';

import type { FeatureHeaderProperties } from './index';
import { getCroppedImageUrl } from '@weee-fe/module';
interface LayoutCenterProps {
  className?: string;
  properties: FeatureHeaderProperties;
}

const CONTENT_MAXWIDTH_CLASS_MAP = {
  [ISize.small]: '566px',
  [ISize.middle]: '566px',
  [ISize.large]: '566px'
} as const;

const LayoutCenter: React.FC<LayoutCenterProps> = ({ properties }) => {
  const { font_size = ISize.middle, mobile_media } = properties;

  if (mobile_media) {
    return (
      <div
        className="w-full bg-center bg-no-repeat bg-cover px-10 py-10 box-border"
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%), url(${getCroppedImageUrl(
            mobile_media,
            {
              renderWidth: 980
            }
          )})`
        }}
        data-testid="mod-featured-header-layout-center">
        <div
          className="flex flex-col items-center mx-auto text-center"
          style={{ maxWidth: CONTENT_MAXWIDTH_CLASS_MAP[font_size] }}>
          <Icon properties={properties} wrapperClassName="mb-5" />
          <SubTitle properties={properties} className="text-[#ffffff]" />
          <Title properties={properties} className="my-3 text-[#ffffff]" />
          <Description properties={properties} className="text-[#ffffff]" />
        </div>
      </div>
    );
  }

  return (
    <div
      className="w-full flex flex-col items-center mx-auto text-center px-10 py-5 box-border"
      style={{ maxWidth: CONTENT_MAXWIDTH_CLASS_MAP[font_size] }}>
      <Icon properties={properties} wrapperClassName="mb-3" />
      <SubTitle properties={properties} />
      <Title properties={properties} className="my-3" />
      <Description properties={properties} />
    </div>
  );
};

export default LayoutCenter;
